import React from "react";
// import styled from "styled-components";
import { AppBar, Toolbar } from "@mui/material";
import LogoRight from "../../../assets/logo.png";
import LogoLeft from "../../../assets/induslnd_logo.png";
import { styled } from "@mui/system";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#fff",
  position: "sticky",
  padding: "0 10%",
  [[theme.breakpoints.between("xs", "lg")]]: {
    padding: "0px 5%",
  },
  [theme.breakpoints.up("lg")]: {
    padding: "10px 10%",
  },
}));

const LogoLeftImg = styled("img")(({ theme }) => ({
  height: "100%",
  objectFit: "contain",
  [[theme.breakpoints.between("xs", "md")]]: {
    maxWidth: "45%",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    maxWidth: "25%",
  },
  [theme.breakpoints.up("lg")]: {
    maxWidth: "18%",
  },
}));
const LogoRightImg = styled("img")(({ theme }) => ({
  height: "100%",
  objectFit: "contain",
  [[theme.breakpoints.between("xs", "md")]]: {
    maxWidth: "45%",
  },
  [[theme.breakpoints.between("md", "lg")]]: {
    maxWidth: "45%",
    height: "80%",
  },
  [theme.breakpoints.up("lg")]: {
    maxWidth: "40%",
    height: "80%",
  },
}));

const MyAppBar = () => {
  return (
    <React.Fragment>
      <StyledAppBar elevation={0}>
        <Toolbar disableGutters style={{ height: "64px" }}>
          <div style={{ flexGrow: 1 }} />
          <LogoLeftImg src={LogoLeft} alt="Left logo" />
          <div style={{ flexGrow: 1 }} />
          {/* <LogoRightImg src={LogoRight} alt="Right logo" /> */}
        </Toolbar>
      </StyledAppBar>
    </React.Fragment>
  );
};

export default MyAppBar;
